var client_id = "6e1dde8891e74eec96e04dfd313e1ebc";
var client_secret = "4b5a5de1e7ba44fea28195400c16b62b";

export {client_id, client_secret};